export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-23.3971cfe9.png";